export const fileTypes = {
  video: "video",
  image: "image",
};
